import Vue from 'vue'
import Buefy from 'buefy'
import App from './App.vue'
import router from './router'
import * as VueGoogleMaps from 'vue2-google-maps'
import {store} from './store/store'
import VeeValidate from 'vee-validate'
import VCalendar from 'v-calendar'

Vue.config.productionTip = false
Vue.use(Buefy)
Vue.use(VeeValidate)
Vue.use(VCalendar)
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.GOOGLE_MAPS_API_KEY,
    libraries: 'places',
  },
})

export const metro = new Vue() // for global events

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
